module.exports = __webpack_public_path__ + "img/recommend.11673d2d.svg";